export enum PersonalDocumentMaxLength {
  DEPARTMENT_CODE = 6,
  PASSPORTSERIES = 10,
  SNILS = 11,
  INN = 12,
  OGRNIP = 15,
}
